export const VERIFICATION_MODEL = 'local-deterministic' as const;

export const EXPECTED_PREPROCESSING_VERSION = 2;

export const EXPECTED_NN_SOURCE = 'hr-derived-polar360';

export const EXPECTED_DETREND_METHOD = 'smooth-priors';

export const EXPECTED_DETREND_LAMBDA = 500;

export const EXPECTED_RESAMPLE_HZ = 4;

export const EXPECTED_SPECTRAL_PATH_PRIMARY = 'nn-reconstructed';

export const EXPECTED_RMSSD_SOURCE = 'nn-delta-rr';

export const EXPECTED_ARTIFACT_METHOD = 'malik-inspired-relative-change';

/** Legacy device path (comparison only in HRV preprocessing pipeline). */
export const EXPECTED_FILTER_APPLIED =
  'Butterworth order 2, cutoff 0.5 Hz, forward-backward';

export const EXPECTED_FFT_METHOD =
  'Welch: window=Hann 256, overlap=50%, nfft=512';

export const PIPELINE_SPEC = {
  minValidPercent: 80,
  smallGapSeconds: 3,
  segmentDurationSeconds: 300,
  samplingRateHz: 1,
  lowPassCutoffHz: 0.5,
  normalization: 'z-score: (y - mean) / std',
  preprocessingVersion: EXPECTED_PREPROCESSING_VERSION,
  nnSource: EXPECTED_NN_SOURCE,
  detrendMethod: EXPECTED_DETREND_METHOD,
  detrendLambda: EXPECTED_DETREND_LAMBDA,
  resampleHz: EXPECTED_RESAMPLE_HZ,
  maxCorrectedBeatRatio: 0.05,
  spectralPathPrimary: EXPECTED_SPECTRAL_PATH_PRIMARY,
  rmssdSource: EXPECTED_RMSSD_SOURCE,
  artifactMethod: EXPECTED_ARTIFACT_METHOD,
  filter: EXPECTED_FILTER_APPLIED,
  fft: EXPECTED_FFT_METHOD,
} as const;

export const PSD_SAMPLE_POINTS = 5;

export const DELTA_TOLERANCE = 0.01;
